<template>
    <div class="help_center">
        <div class="delegate yl-flex">
            <div  class="hand dele" @click="() => {menuName = menu.key}" :class="{'active': menu.key == menuName}" v-for="(menu,index) in menuList" :key="index">
                {{menu.name}}
            </div>
        </div>
        <div>
            <div style="width: 100%; min-height: 300px;padding: 20px;background-color: #FFFFFF;" v-if="menuName == 'base'">
                <Form ref="formValidate" :label-width="120">
                    <div style="text-align: right; padding-right: 30px; margin: 10px 0">
                        <Button type="primary" @click="save">保存</Button>
                    </div>
                    <div>
                        <FormItem label="站点名称">
                            <Input v-model="set['name']" placeholder="请输入站点名称"></Input>
                        </FormItem>
                        <FormItem label="站点logo">
                            <div style="display: flex; justify-content: space-between;align-items: center; width: 90%">
                                <div v-if="set.logo"><img style="width: 130px; height: 50px; border-radius: 50%" :src="set.logo"></div>
                                <Button type="primary" @click="uploadLogo">上传logo</Button>
                            </div>
                            <div>建议130*50</div>
                        </FormItem>
                        <FormItem label="站点图标">
                            <div style="display: flex; justify-content: space-between;align-items: center; width: 90%">
                                <div v-if="set.icon"><img style="width: 80px; height: 80px; border-radius: 50%" :src="set.icon"></div>
                                <Button type="primary" @click="uploadIcon">上传图标</Button>
                            </div>
                            <div>建议100*100</div>
                        </FormItem>
                    </div>
                    <div>
                        <FormItem label="客服微信">
                            <Input v-model="set['service_wx']" placeholder="请输入客服微信"></Input>
                        </FormItem>
                        <FormItem label="vip坐席原价">
                            <Input v-model="set['vip_origin_price']" placeholder="请输入vip坐席原价"></Input>
                        </FormItem>
                    </div>
					<div>
					    <FormItem label="只能短信登录">
							 <i-switch v-model="set['is_sms_code_login']" @on-change="changeLoginType" />
					    </FormItem>
					</div>
                </Form>
            </div>
            <div style="width: 100%; min-height: 300px;background-color: #FFFFFF;padding: 20px;" v-if="menuName == 'account'">
                <Form ref="formValidate" :label-width="120">
                    <div style="text-align: right; padding-right: 30px; margin: 10px 0">
                        <Button type="primary" @click="save">保存</Button>
                    </div>
                    <FormItem label="收款人">
                        <Input v-model="set['bank_person_name']" placeholder="请输入收款人"></Input>
                    </FormItem>
                    <FormItem label="开户行">
                        <Input v-model="set['bank_name']" placeholder="请输入开户行"></Input>
                    </FormItem>
                    <FormItem label="账号">
                        <Input v-model="set['bank_account']" placeholder="请输入账号"></Input>
                    </FormItem>
                </Form>
            </div>
        </div>

        <Modal
                v-model="uploadModal"
                title="上传图片"
                @on-cancel="() => {uploadModal = false}"
                @on-ok="fileOk">
            <addFile ref="addFile" :needFileName="0" :fileFormat="['jpg','jpeg','png','gif']"></addFile>
        </Modal>
    </div>
</template>

<script>
    import TopBar from '../topbar/TopBar.vue';
    import addFile from '../tool/addFile.vue';
    import {mapGetters} from 'vuex';
    import {saveAdminSet, getAdminSet} from '@/api/admin'

    export default {
        name: "adminSet",
        components: {
            TopBar,addFile
        },
        computed:{
            ...mapGetters(['userInfo', 'token']),
        },
        data() {
            return {
                menuList: [
                    {key: 'base', name: '基本设置'},
                    {key: 'account', name: '账户设置'},
                ],
                menuName: 'base',
                uploadType: '',
                uploadModal: false,
                set: {
                    name: '',
                    logo: '',
                    icon: '',
                    bank_person_name: '',
                    bank_name: '',
                    bank_account: '',
                    service_wx: '',
                    vip_origin_price: '',
					is_sms_code_login:false
                }
            }
        },
        created(){
            this.loadData();
        },
        methods: {
            uploadLogo() {
                this.uploadType = 'logo';
                this.uploadModal = true
            },
            uploadIcon() {
                this.uploadType = 'icon';
                this.uploadModal = true
            },
            fileOk() {
                var that = this;
                that.set[this.uploadType] = that.$refs['addFile'].fileUrl;
                that.$refs['addFile'].clear();
            },
            async loadData() {
                let that = this;
                let data = {token: that.token, set:that.set}
                let res = await getAdminSet(that, data);
                if (res.code == 1) {
                    that.set = res.data.set;
                }
            },
            save() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, set:that.set}
                    let res = await saveAdminSet(that, data);
                    if (res.code == 1) {
                        that.$Message.success('保存成功')
                    }
                }, 1000);
            },
			changeLoginType (status) {
				if(status){
					this.$Message.info('只能短信登录状态开启');
				}else{
					this.$Message.info('只能短信登录状态关闭');
				}
            }
        }
    }
</script>

<style scoped lang="less">
    .help_center {
        height: 100%;
        background: #f5f7f9;
    }

    .yl-flex {
        display: flex;
        justify-content: space-between;
    }
    .ivu-form-item{
        display: inline-block;
        width: 300px;
        margin-left: 15px;
    }
    .delegate {
        justify-content: start;
        align-items: flex-end;
    }
    .dele {
        font-size: 12px;
        padding: 0 25px;
        border: 1px solid #e0e2e6;
        color: #666;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    .dele.active {
        padding: 5px 20px;
        background: #0092ff;
        color: #fff;
    }
</style>
